module.exports = __webpack_public_path__ + "static/media/linsheng_match_01.897eb729.png";